import gql from 'graphql-tag';

export const createRoom = gql`
  mutation NewRoom($name: String, $roomTypeId: ID, $roomPackageId: ID, $roomPartnerFlowId: ID) {
    createRoom(
      name: $name
      roomTypeId: $roomTypeId
      roomPackageId: $roomPackageId
      roomPartnerFlowId: $roomPartnerFlowId
    ) {
      id,
      name,
      roomType {
        type
      }
      roomStatus {
        id
      }
      roomPackage {
        id
        type
      }
    }
  }
`;

export default createRoom;
